export default {"src":"/_next/static/media/clear.c93c9206.svg","height":72,"width":270,"blurWidth":0,"blurHeight":0};